import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "withdrawal-form"
}
const _hoisted_2 = { class: "withdrawal-form__address withdrawal-form-address" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "withdrawal-form__hint" }, "The withdrawal process is automatic. Usually, it takes anywhere from 10 minutes to 2-3 hours. However, as a maximum, it can take up to 7 days. The bot needs to close all active trades in order to withdraw the money.", -1)
const _hoisted_4 = { class: "withdrawal-form__amount withdrawal-form-amount" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "withdrawal-form-amount__currency" }, "USDT", -1)
const _hoisted_6 = {
  key: 0,
  class: "withdrawal-form__balance"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "USDT", -1)
const _hoisted_8 = { class: "withdrawal-form__balance" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "USDT", -1)
const _hoisted_10 = { class: "withdrawal-form__comission" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "USDT", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "withdrawal-form__alert" }, "*The commission is charged from the amount. We charge a 10% fee on withdrawals.", -1)
const _hoisted_13 = {
  key: 1,
  class: "withdrawal-confirmation"
}
const _hoisted_14 = { class: "withdrawal-confirmation__row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "withdrawal-confirmation__option" }, "Recipient", -1)
const _hoisted_16 = { class: "withdrawal-confirmation__value" }
const _hoisted_17 = { class: "withdrawal-confirmation__row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "withdrawal-confirmation__option" }, "Amount", -1)
const _hoisted_19 = { class: "withdrawal-confirmation__value" }
const _hoisted_20 = { class: "withdrawal-confirmation__row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "withdrawal-confirmation__option" }, "Commission", -1)
const _hoisted_22 = { class: "withdrawal-confirmation__value" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "withdrawal-confirmation__alert" }, " * The commission is charged from the remaining balance. We charge a 10% fee on withdrawals. ", -1)
const _hoisted_24 = {
  key: 0,
  class: "withdrawal__success withdrawal-success"
}
const _hoisted_25 = { class: "withdrawal-success__icon" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "withdrawal-success__text" }, "Done!", -1)

import "./WithdrawalView.scss";
import Button from "@/components/Button/Button.vue";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import ModalLayout from "@/layouts/ModalLayout/ModalLayout.vue";
import {computed, ref, watch} from "vue";
import Icon from "@/components/Icon/Icon.vue";
import TelegramWebApp from "@/telegram/TelegramWebApp";
import Loader from "@/components/Loader/Loader.vue";
import {useUserStore} from "@/stores/userStore";
import {storeToRefs} from "pinia";
import {useApiStore} from "@/stores/apiStore";
import {useAlertsStore} from "@/stores/alertsStore";
import ApiError from "@/modules/Api/ApiError";
import {shorty} from "@/modules/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawalView',
  setup(__props) {

let userStore = useUserStore();
let alertsStore = useAlertsStore();
let {api} = useApiStore();

let {me} = storeToRefs(userStore);

let ready = ref<boolean>(false);
let loading = ref<boolean>(false);
let complete = ref<boolean>(false);

let amount = ref<string>('0');
let commission = ref<number>(0);
let address = ref<string>('');

let filled = computed<boolean>(() => {
	return !!(address.value.length && amount.value.length && +amount.value > 0);
});

let scanAddress = () => {

	TelegramWebApp.app!.showScanQrPopup({ text: 'Scan QR' }, (data) => {

		if(data){
			address.value = data;

			TelegramWebApp.app!.closeScanQrPopup();
		}

	});

}

let pasteAddress = async () => {

	address.value = await navigator.clipboard.readText();

}

let loadCommission = async () => {

	try {
		commission.value = await api.calculateWithdrawalCommission(+amount.value);
	}catch (e){
		commission.value = 0;
	}

}

let onBack = computed<boolean | Function>(() => {

	if(loading.value){
		return false;
	}

	if(!ready.value){
		return true;
	}

	if(complete.value){
		return true;
	}

	return () => {
		ready.value = false;
	};

});

let onSubmit = async () => {

	if(!ready.value){

		if(!filled.value){
			return;
		}

		loading.value = true;

		if(!await api.validateWithdrawalAddress(address.value)){
			alertsStore.pushError('Address is incorrect');
			loading.value = false;
		}

		ready.value = true;
		loading.value = false;

		ready.value = filled.value;


	}else{

		loading.value = true;

		try{

			await api.withdrawal(+amount.value, address.value);

			complete.value = true;
			loading.value = false;

		}catch(e){

			if(e instanceof ApiError){
				alertsStore.pushError(e.message);
				loading.value = false;

				return;
			}

			throw e;

		}

	}


}

watch(amount, async () => {
	await loadCommission();
});


return (_ctx: any,_cache: any) => {
  const _directive_auto_size = _resolveDirective("auto-size")!

  return (_openBlock(), _createBlock(ModalLayout, {
    title: "USDT Transfer",
    back: _unref(onBack)
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "withdrawal section--mini section screen-start",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
      }, [
        (!_unref(ready))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "withdrawal-form-address__input",
                  required: "",
                  placeholder: "Address name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(address) ? (address).value = $event : address = $event))
                }, null, 512), [
                  [_vModelText, _unref(address)]
                ]),
                _createElementVNode("button", {
                  class: "withdrawal-form-address__paste",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(pasteAddress) && _unref(pasteAddress)(...args)))
                }, "Paste"),
                _createElementVNode("button", {
                  class: "withdrawal-form-address__scan",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scanAddress) && _unref(scanAddress)(...args)))
                }, [
                  _createVNode(Icon, { name: "scan" })
                ])
              ]),
              _hoisted_3,
              _createElementVNode("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "withdrawal-form-amount__input",
                  inputmode: "decimal",
                  required: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(amount) ? (amount).value = $event : amount = $event))
                }, null, 512), [
                  [_vModelText, _unref(amount)],
                  [_directive_auto_size]
                ]),
                _hoisted_5
              ]),
              false
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                    _createTextVNode("Current balance: "),
                    _createElementVNode("b", null, _toDisplayString(_unref(me).balance.toFixed(2)), 1),
                    _createTextVNode(),
                    _hoisted_7
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode("Commission: "),
                _createElementVNode("b", null, _toDisplayString(_unref(commission).toFixed(2)), 1),
                _createTextVNode(),
                _hoisted_9
              ]),
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode("Available for withdrawal*: "),
                _createElementVNode("b", null, _toDisplayString(_unref(me).balance.toFixed(2)), 1),
                _createTextVNode(),
                _hoisted_11
              ]),
              _hoisted_12
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("b", null, _toDisplayString(_unref(shorty)(_unref(address), 8)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, [
                  _createElementVNode("b", null, _toDisplayString(_unref(amount)), 1),
                  _createTextVNode(" USDT ")
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, [
                  _createElementVNode("b", null, _toDisplayString(_unref(commission)), 1),
                  _createTextVNode(" USDT ")
                ])
              ]),
              _hoisted_23
            ])),
        _createVNode(_Transition, { name: "footer-button" }, {
          default: _withCtx(() => [
            (!_unref(ready))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  color: "brand",
                  class: "withdrawal__button",
                  size: "big",
                  disabled: !_unref(filled) || _unref(loading)
                }, {
                  default: _withCtx(() => [
                    (_unref(loading))
                      ? (_openBlock(), _createBlock(Loader, {
                          key: 0,
                          size: "30"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Continue")
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "footer-button" }, {
          default: _withCtx(() => [
            (_unref(ready) && !_unref(complete))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  color: "brand",
                  class: "withdrawal__button",
                  size: "big",
                  disabled: _unref(loading)
                }, {
                  default: _withCtx(() => [
                    (_unref(loading))
                      ? (_openBlock(), _createBlock(Loader, {
                          key: 0,
                          size: "30"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Confirm and send")
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "footer-button" }, {
          default: _withCtx(() => [
            (_unref(complete))
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("i", _hoisted_25, [
                    _createVNode(Icon, {
                      name: "check",
                      size: 2
                    })
                  ]),
                  _hoisted_26
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["back"]))
}
}

})